
module dg.objects {


    //interface IDateRangeSelectOptions {
    //    
    //}

    export interface IValidationParams {
        min: number,
        max: number
    }

    export interface IDateRange {
        min: any,
        max: any
    };

    export class CustomDateRangeService {

        public constructor(
            private moment: any) {
        }

        private dateRangeOptions = {
            //'1W': {
            //    title: 'Last Week',
            //    shortTitle: '1W',
            //    min: this.moment().subtract(1, 'week'),
            //    max: this.moment()
            //},
            '1M': {
                title: 'Current Month',
                shortTitle: '1M',
                min: this.moment().startOf('month'),
                max: this.moment()
            },
            '3M': {
                title: 'Last 3 Months',
                shortTitle: '3M',
                min: this.moment().startOf('month').subtract(2, 'months'),
                max: this.moment()
            },
            '6M': {
                title: 'Last 6 Months',
                shortTitle: '6M',
                min: this.moment().startOf('month').subtract(5, 'months'),
                max: this.moment()
            },
            '1Y': {
                title: 'Last Year',
                shortTitle: '1Y',
                min: this.moment().startOf('month').subtract(11, 'months'),
                max: this.moment()
            },
            'LY': {
                title: 'Last Year',
                shortTitle: 'LY',
                min: this.moment().subtract(1, 'year').startOf('year'),
                max: this.moment().subtract(1, 'year').endOf('year')
            },
            'CY': {
                title: 'Current Year',
                shortTitle: 'CY',
                min: this.moment().startOf('year'),
                max: this.moment()
            },
            CR: {
                shortTitle: 'CR',
                title: 'Custom Range'
            }
        };


        public getPeriodByRange(minDate, maxDate) {
            let period = null;
            for (let range in this.dateRangeOptions) {
                if (this.dateRangeOptions.hasOwnProperty(range) && this.dateRangeOptions[range]['min'] && this.dateRangeOptions[range]['max']) {
                    if (this.dateRangeOptions[range].min.isSame(minDate, 'day')
                        && this.dateRangeOptions[range].max.isSame(maxDate, 'day')) {
                        period = this.dateRangeOptions[range];
                    }
                }
            }

            return period;
        }

        public getDateRangeOptions() {
            return this.dateRangeOptions;
        }

        public convertToClient(dateRangeValue: dg.domain.model.Range<any>) {
            if (dateRangeValue) {
                let result: IDateRange = {
                    min: dateRangeValue.min,
                    max: dateRangeValue.max
                }
                return result;
            }
            
            return null;
        }

        public checkValidity(dateRange: IDateRange, isRequired: boolean) {

            if (dateRange && isRequired) {
                //if (this.moment(dateRange.max).diff(this.moment(dateRange.min), 'days') > validationParams.max
                //    || this.moment(dateRange.max).diff(this.moment(dateRange.min), 'days') < validationParams.min
                //    || !dateRange.max) {
                //    return false;
                //}
                return true;
            }
            else if (!dateRange && isRequired) {
                return false;
            }
            else if (!isRequired) {
                return true;
            }

        }
        public convertToServer(dateRangeValue: IDateRange) {

            if (dateRangeValue) {

                let result: IDateRange = {
                    min: dateRangeValue.min,
                    max: dateRangeValue.max
                }
                return result;

            }
            else {
                return null;
            }
        }

        public addDaysToDate = (currentDate: Date, days: number) => {
            let date = { ...currentDate };
            return date.setDate(currentDate.getDate() + days);
        }

        public getValidationRule(rules: dg.restfulApi.ValidationRule[], validationRuleType: string) {
            let validationRule = rules.filter((v, i) => {
                return v.type == validationRuleType;
            })[0];

            //validationRule = _.find(domainObjectCtrl.value.dgMeta.properties[property].extensions.validation.rules, (obj: any) => {
            //    return obj.type == validationRuleType;
            //});

            return validationRule;
        }
    }

    angular.module('dg.objects')
        .service('customDateRangeService', CustomDateRangeService);
}